import React from 'react'
import styled from 'styled-components'
import { FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import { MdAccessTimeFilled } from "react-icons/md";



const Wrapper= styled.section`
background:#EC632F;
padding-top: 10%;
padding-bottom: 8%;
h2{
  color: #fff;
  margin-left: 21px;
}
.links-div{
  display: none;
}
p{
  color: #fff;

  margin-left:21px;
  margin-right: 29px;
line-height: 1.3;
margin-bottom: 7%;
margin-top: 7%;
}
.img-2{
    width: 90%;
  display: flex;
  margin: 0 auto;
padding-bottom: 5%;
}
.all-div-combo{
    display: flex;
    flex-direction: column;
    /* gap: 20px; */
}

.div-1-combo{
    h2{
    margin-left:21px;
    padding-bottom: 7%;
    padding-top: 5%;
}
ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 5px;
  }
  li{
    color: #fff;

  }
}

.div-2-combo{
    display: flex;
    flex-direction: column;
    gap: 20px;
    h2{
    margin-left:21px;
    padding-bottom: 2%;
    padding-top: 10%;
}
.text-image{
    margin-left: 21px;
    display: flex;
    align-items: center;
}
.text{
    display: flex;
    flex-direction: column;
    gap: 5px;
 p{
  color: #fff;
    margin-top: 0;
    margin-bottom: 0;
 }
}
svg{
    color:#fff;
}
.svg-div{
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
}



@media (min-width: 768px) {
  .div-2-combo{
    display: flex;
    flex-direction: column;
    gap: 20px;
    h2{
    margin-left:21px;
    padding-bottom: 0%;
    padding-top: 0%;
}
.text-image{
    margin-left: 21px;
    display: flex;
    align-items: center;
}
.text{
    display: flex;
    flex-direction: column;
    gap: 5px;
 p{
  color: #fff;
    margin-top: 0;
    margin-bottom: 0;
 }
}
svg{
    color:#fff;
}
.svg-div{
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
}
  .all-div-combo{
    display: flex;
    flex-direction: column;
    gap: 30px;
}
.a-1{
display: flex;
}
.a-2{
display: flex;
}
  .div-comboAll-1{
    display: flex;
    flex-direction: row;
    gap: 100px;
  }
  .div-comboAll-2{
    display: flex;
    flex-direction: row;
    gap: 50px;
  }
  .img-2{
    margin-left: 25px;
    width: 70%;
    height: 180px;
    object-fit: cover;
  display: flex;
padding-bottom: 1%;
}
h2{
  color: #fff;
  margin-left: 21px;
  margin-right: 91px;
}
p{
  color: #fff;
  margin-left:21px;
  margin-right: 41px;
line-height: 1.3;
margin-bottom: 3%;
margin-top: 1%;
}
.h2-p-img-div-combo{
  display: flex;
  gap: 6px;
  width: 50%;
}
.links-div{
  display: block;
  h2{
    margin-left:21px;
    padding-bottom: 7%;
    padding-top: 5%;
}
ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 5px;
  }
  li{
    color: #fff;

  }

}
}


@media (min-width: 992px) {
  .div-2-combo{
    display: flex;
    flex-direction: column;
    gap: 20px;
    h2{
    margin-left:21px;
    padding-bottom: 0%;
    padding-top: 0%;
}
.text-image{
    margin-left: 21px;
    display: flex;
    align-items: center;
}
.text{
    display: flex;
    flex-direction: column;
    gap: 5px;
 p{
  color: #fff;
    margin-top: 0;
    margin-bottom: 0;
 }
}
svg{
    color:#fff;
}
.svg-div{
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
}
  .all-div-combo{
    display: flex;
    flex-direction: column;
    gap: 50px;
}
.a-1{
display: flex;
gap: 120px;
}
.a-2{
display: flex;
gap: 100px;

}
  .div-comboAll-1{
    display: flex;
    flex-direction: row;
    gap: 170px;
    margin-left: 20px;
  }
  .div-comboAll-2{
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    gap: 150px;
  }
  .img-2{
    margin-left: 25px;
    width: 200%;
    height: 200px;
    object-fit: cover;
  display: flex;
padding-bottom: 1%;
}
h2{
  color: #fff;
  margin-left: 21px;
  margin-right: 91px;
}
p{
  color: #fff;
  margin-left:21px;
  margin-right: 41px;
line-height: 1.3;
margin-bottom: 3%;
margin-top: 1%;
}
.h2-p-img-div-combo{
  display: flex;
  gap: 90px;
  width: 50%;
}
.links-div{
  display: block;
  h2{
    margin-left:21px;
    padding-bottom: 7%;
    padding-top: 5%;
}
ul{
    
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 5px;
  }
  li{
    color: #fff;

  }

}
}


@media (min-width: 1200px) {
  padding-top: 5%;
padding-bottom: 5%;

  .div-1-combo{
    position: relative;
    right: 50px;
ul{
  gap: 20px;
  }
  li{
    color: #fff;
width: max-content;
  }
}
  .div-2-combo{
    display: flex;
    flex-direction: column;
    gap: 20px;
    h2{
    margin-left:0px;
    padding-bottom: 0%;
    padding-top: 0%;
    width: max-content;
}

.text-image{
    margin-left: 21px;
    display: flex;
    align-items: center;
    gap: 15px;
}
.text{
    display: flex;
    flex-direction: column;
    gap: 5px;
 p{
  font-size: 15px;
  color: #fff;
    margin-top: 0;
    margin-bottom: 0;
    width: max-content;
 }
}
svg{
    color:#fff;
}
.svg-div{
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
}
  .all-div-combo{
    display: flex;
    flex-direction: row;
    gap: 10px;
}
.a-1{
display: flex;
flex-direction: column;
gap: 15px;
}
.a-2{
display: flex;
flex-direction: column;
gap: 15px;

}
  .div-comboAll-1{
    display: flex;
    flex-direction: row;
    gap: 0px;
    margin-left: 0px;
  }
  .div-comboAll-2{
    display: flex;
    flex-direction: row;
    margin-left: 0px;
    position: relative;
    left: 75px;
    gap: 100px;
  }
  .img-2{
    margin-left: 0px;
    width: 55%;
    height: 180px;
    object-fit: cover;
  display: flex;
padding-bottom: 1%;
}
h2{
  color: #fff;
  margin-left: 0px;
  font-size: 25px;
  font-weight: 600;
  margin-right: 0px;
  margin-bottom: 15px;

}
p{
  font-size: 16px;
  color: #fff;
  margin-left:0px;
  margin-right: 160px;
line-height: 1.3;
margin-bottom: 3%;
margin-top: 1%;
}
.h2-p-img-div-combo{
  display: flex;
  flex-direction: column;
  gap: 5px;
  width:unset;
  margin-left: 90px;
}
.links-div{
  display: block;
  h2{
    margin-left:21px;
    padding-bottom: 7%;
    padding-top: 5%;
}
ul{
    list-style: disc;
    margin-left:40px;
display: flex;
flex-direction: column;
gap: 20px;
  }
  li{
    color: #fff;
    width: max-content;
  }

}
}
`
function Information() {
  return (
    <Wrapper>

<div className='all-div-combo'>

<div className='div-comboAll-1'>
  
      <div className='h2-p-img-div-combo'>
      <div>
         <h2>Useful Information</h2>
        <p className='first-p' > Favour Pre-School and Day Care Center provides broad range of learning programs and activities that's unique in itself</p>
        </div>
        <img  className='img-2' src="./photos/kidswalking.png" alt="photo"/>
        </div>

         <div className='div-1-combo'>
            <h2>Our Activities</h2>
            <ul>
                <li>Mountain Trekking Programs</li>
                <li>Inter School Competitions</li>
                <li>Awards and Ceremony</li>
                <li>Graduation Events</li>
                <li>Quiz Competitions</li>
                <li>Fashion Day</li>
                <li>Talents Competitions</li>
            </ul>
         </div>
 </div>

 <div className='div-comboAll-2'>

<div className='links-div'>
  <h2>Links</h2>
  <ul>
    <li className='active-link'><a>Home</a></li>
    <li><a>About</a></li>
    <li><a>Services</a></li>
    <li><a>Gallery</a></li>
    <li><a>Contact</a></li>
  </ul>
</div>

         <div className='div-2-combo'>
            <h2>Get In Touch</h2>

            <div className='a-1'>
            <div className='text-image'>
           <div className='svg-div'> <FaPhone /></div>
              <div className='text'>
                <p>+263 78 632 7777</p>
                <p>+263 78 632 7777</p>
              </div>
            </div>

            <div className='text-image'>
            <div className='svg-div'><IoIosMail /></div>
              <div className='text'>
                <p>favour@gmail.com</p>
                <p>favour@gmail.com</p>
              </div>
            </div>
            </div>

            <div className='a-2'>
            <div className='text-image'>
            <div className='svg-div'><IoLocationSharp /></div>
              <div className='text'>
                <p>1623 Mbundane,</p>
                <p>Bulawayo, Zimbabwe</p>
              </div>
            </div>

            <div className='text-image'>
            <div className='svg-div'> <MdAccessTimeFilled /></div>
              <div className='text'>
                <p>Mon - Fri</p>
                <p>07:00am - 17:00pm</p>
              </div>
            </div>
            </div>

         </div>
 </div>

     </div>
    </Wrapper>
  )
}

export default Information
